import { render, staticRenderFns } from "./RevitElementDetailsTab.vue?vue&type=template&id=8affaec2&scoped=true"
import script from "./RevitElementDetailsTab.vue?vue&type=script&lang=ts"
export * from "./RevitElementDetailsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8affaec2",
  null
  
)

export default component.exports